// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  height: 100%;
}

html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow-x: hidden;
}

/* 与 Electron / index.html 中 #root 的 flex 列布局配合，保证主区域可接收滚轮并滚动 */
#root {
  height: 100%;
  display: flex;
  flex-direction: column;
}

#app {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 手机/平板：外壳锁在视口内，只让主内容滚动，避免整页滚出底部导航 */
@media (max-width: 1199px) {
  html,
  body {
    height: 100%;
    overflow: hidden;
  }

  #root,
  #app {
    height: 100% !important;
    min-height: 0 !important;
    overflow: hidden;
  }
}

/* ========== 浏览器 / PWA 移动体验（Electron 不受影响：主要为 WebView 与手机 Safari/Chrome） ========== */
@media (max-width: 767px) {
  .ant-btn {
    min-height: 40px;
  }

  .ant-input,
  .ant-select-selector,
  .ant-picker {
    min-height: 40px;
  }

  .ant-table {
    font-size: 13px;
  }

  .ant-table-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .ant-modal {
    max-width: calc(100vw - 16px) !important;
    margin: 8px auto !important;
  }

  .ant-tabs-tab {
    padding: 10px 12px !important;
  }
}

button,
a,
[role='button'] {
  touch-action: manipulation;
}

`, "",{"version":3,"sources":["webpack://./src/renderer/index.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA,+DAA+D;AAC/D;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE;;IAEE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;IAEE,uBAAuB;IACvB,wBAAwB;IACxB,gBAAgB;EAClB;AACF;;AAEA,sFAAsF;AACtF;EACE;IACE,gBAAgB;EAClB;;EAEA;;;IAGE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,wCAAwC;IACxC,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;;;EAGE,0BAA0B;AAC5B","sourcesContent":["html {\r\n  height: 100%;\r\n}\r\n\r\nhtml,\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  height: 100%;\r\n  overflow-x: hidden;\r\n}\r\n\r\n/* 与 Electron / index.html 中 #root 的 flex 列布局配合，保证主区域可接收滚轮并滚动 */\r\n#root {\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n#app {\r\n  flex: 1;\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n/* 手机/平板：外壳锁在视口内，只让主内容滚动，避免整页滚出底部导航 */\r\n@media (max-width: 1199px) {\r\n  html,\r\n  body {\r\n    height: 100%;\r\n    overflow: hidden;\r\n  }\r\n\r\n  #root,\r\n  #app {\r\n    height: 100% !important;\r\n    min-height: 0 !important;\r\n    overflow: hidden;\r\n  }\r\n}\r\n\r\n/* ========== 浏览器 / PWA 移动体验（Electron 不受影响：主要为 WebView 与手机 Safari/Chrome） ========== */\r\n@media (max-width: 767px) {\r\n  .ant-btn {\r\n    min-height: 40px;\r\n  }\r\n\r\n  .ant-input,\r\n  .ant-select-selector,\r\n  .ant-picker {\r\n    min-height: 40px;\r\n  }\r\n\r\n  .ant-table {\r\n    font-size: 13px;\r\n  }\r\n\r\n  .ant-table-wrapper {\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n\r\n  .ant-modal {\r\n    max-width: calc(100vw - 16px) !important;\r\n    margin: 8px auto !important;\r\n  }\r\n\r\n  .ant-tabs-tab {\r\n    padding: 10px 12px !important;\r\n  }\r\n}\r\n\r\nbutton,\r\na,\r\n[role='button'] {\r\n  touch-action: manipulation;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
